var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.componentType, {
    ref: "input",
    tag: "component",
    attrs: {
      dense: "",
      outlined: "",
      "hide-details": "",
      "single-line": "",
      "return-object": false,
      value: _vm.value,
      items: _vm.items,
      label: _vm.label,
      clearable: _vm.clearable,
      "prepend-inner-icon": _vm.icon,
      "data-testid": _vm.dataTestid,
      disabled: _vm.disabled,
      loading: _vm.loading,
      "search-input": _vm.searchInput,
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInput = $event
      },
      "update:search-input": function ($event) {
        _vm.searchInput = $event
      },
      input: function (value) {
        return _vm.$emit("input", value)
      },
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.closeMenuAfterConfirmation.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }